export default __webpack_public_path__ + "static/media/cobject2.aa3f3f1c.svg";